export default "__VITE_PUBLIC_ASSET__53f99450__"